export type Bonus = {
  number: string
  title: string
  body: string
  /** URL pública de la portada. Vacío = se muestra una portada diseñada de respaldo. */
  cover: string
  accent: string
}

/**
 * Los 5 bonus reales del pack (ficha DPS43 · Troop Night Ready, sección 6).
 * Portadas en Drive > mockup (DPS43 - Bono 1..5). Pegá la URL pública en `cover`.
 */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Meeting Picker + 10-Minute Prep Routine',
    body: 'Answer five questions — ages, space, weather, time, adults — and the chart points you to the right meeting for tonight. Then a one-page routine takes you from “nothing planned” to “ready” in ten minutes.',
    cover: 'https://cdn.magicpatterns.com/uploads/jq3U3QoJyhNkkP9tFPpTnf/DPS43_-_Bono_1_-_The_Meeting_Picker_2B_10-Minute_Prep_Routine.png',
    accent: 'bg-ember',
  },
  {
    number: '02',
    title: 'The Troop Night Supply Box',
    body: 'One master list of everything the 60 meetings use, grouped so you buy it once, store it in one box and stop hunting for supplies every week. Plus what to buy first if you’re starting with little, and printable box labels.',
    cover: 'https://cdn.magicpatterns.com/uploads/tksPT8EzEJZqfZW67vjvzv/DPS43_-_Bono_2_-_The_Troop_Night_Supply_Box.png',
    accent: 'bg-patrol-mustard',
  },
  {
    number: '03',
    title: 'The Badge Bridge Map',
    body: 'Map every meeting to your own program’s badges and awards with one simple template — whatever country or organization you lead in. Includes a worked example.',
    cover: 'https://cdn.magicpatterns.com/uploads/khAjedhcvj4r7ckPsYMksk/DPS43_-_Bono_3_-_The_Badge_Bridge_Map.png',
    accent: 'bg-sky',
  },
  {
    number: '04',
    title: 'Risk Planning Prompts',
    body: 'One-page question cards that walk you through your organization’s own risk form for hall games, park games, extreme weather, travel and new sites. Starting prompts, not a completed risk assessment.',
    cover: 'https://cdn.magicpatterns.com/uploads/4ja43AYGUnfSgmnpZ4hea4/DPS43_-_Bono_4_-_Risk_Planning_Prompts.png',
    accent: 'bg-signal',
  },
  {
    number: '05',
    title: 'Trail Skill Certificates',
    body: '20 print-ready certificates and pocket cards to celebrate every skill your group masters — one per skill block, plus “Great Teammate” and “Top Helper” — so progress feels real between badges.',
    cover: 'https://cdn.magicpatterns.com/uploads/7Pu5z94Tax5AZ83ZmYGF7n/DPS43_-_Bono_5_-_Trail_Skill_Certificates.png',
    accent: 'bg-moss',
  },
]
